import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import handleFrameResize from './subjectHandlers/lti.frameResize';
import handleCapabilities from './subjectHandlers/lti.capabilities';
import forwardMessage from './subjectHandlers/forwardMessage';
import handlePutData from './subjectHandlers/lti.put_data';
import handleGetData from './subjectHandlers/lti.get_data';
import handleFetchWindowSize from './subjectHandlers/lti.fetchWindowSize';
import handleRequestFullWindowLaunch from './subjectHandlers/requestFullWindowLaunch';
var PostMessageService = /*#__PURE__*/_createClass(function PostMessageService() {
  var _this = this;
  _classCallCheck(this, PostMessageService);
  _defineProperty(this, "BAD_REQUEST_ERROR_CODE", 'bad_request');
  _defineProperty(this, "GENERIC_ERROR_CODE", 'error');
  _defineProperty(this, "subjectNotAllowed", function (subject) {
    return !_this.handlerMap.has(subject);
  });
  _defineProperty(this, "messageHandlerDispatcher", function (event) {
    if (_this.subjectNotAllowed(event.data.subject)) {
      return null;
    }
    return _this.handlerMap.get(event.data.subject)(event, _this);
  });
  _defineProperty(this, "subjectAllowList", function () {
    return Array.from(_this.handlerMap.keys());
  });
  _defineProperty(this, "capabilities", function () {
    return _this.subjectAllowList().map(function (subject) {
      return {
        subject: subject
      };
    });
  });
  _defineProperty(this, "configurePostMessageListener", function () {
    window.addEventListener('message', _this.messageHandlerDispatcher);
  });
  _defineProperty(this, "cleanupPostMessageListener", function () {
    window.removeEventListener('message', _this.messageHandlerDispatcher);
  });
  _defineProperty(this, "sendResponse", function (subject, data, sourceWindow, origin) {
    sourceWindow.postMessage(_objectSpread({
      subject: subject + '.response'
    }, data), origin);
  });
  _defineProperty(this, "sendSuccessPostMessageResponse", function (subject, message, sourceWindow, origin) {
    _this.sendResponse(subject, {
      message: message
    }, sourceWindow, origin);
  });
  _defineProperty(this, "sendErrorPostMessageResponse", function (subject, message, code, sourceWindow, origin) {
    _this.sendResponse(subject, _this.buildError(code, message), sourceWindow, origin);
  });
  _defineProperty(this, "sendBadRequestErrorPostMessageResponse", function (subject, errorMessage, sourceWindow, origin) {
    _this.sendErrorPostMessageResponse(subject, errorMessage, _this.BAD_REQUEST_ERROR_CODE, sourceWindow, origin);
  });
  _defineProperty(this, "sendGenericErrorPostMessageResponse", function (subject, errorMessage, sourceWindow, origin) {
    _this.sendErrorPostMessageResponse(subject, errorMessage, _this.GENERIC_ERROR_CODE, sourceWindow, origin);
  });
  _defineProperty(this, "buildError", function (code, message) {
    var error = {
      code: code
    };
    if (message) {
      error.message = message;
    }
    return error;
  });
  this.handlerMap = new Map();
  this.handlerMap.set('lti.fetchWindowSize', handleFetchWindowSize);
  this.handlerMap.set('lti.frameResize', handleFrameResize);
  this.handlerMap.set('lti.capabilities', handleCapabilities);
  this.handlerMap.set('lti.setUnloadMessage', forwardMessage);
  this.handlerMap.set('lti.removeUnloadMessage', forwardMessage);
  this.handlerMap.set('lti.screenReaderAlert', forwardMessage);
  this.handlerMap.set('lti.showAlert', forwardMessage);
  this.handlerMap.set('lti.put_data', handlePutData);
  this.handlerMap.set('lti.get_data', handleGetData);
  this.handlerMap.set('requestFullWindowLaunch', handleRequestFullWindowLaunch);
});
export { PostMessageService as default };